<template>
  <v-container style="font-family: Lato, sans-serif">
    <v-row style="height: 500px">
      <v-col>
        <p style="text-align: center; margin-top: 12em">{{ getErrorMessage() }}</p>
        <span v-if="displayRefreshBtn" style="display: flex; justify-content: center; margin-top: 3em">
          <v-btn
            :color="$vuetify.theme.currentTheme.primary"
            :dark="$vuetify.theme.dark"
            class="primary"
            depressed
            href="/"
            tile
          >
            {{ $t('token.loadRefresh') }}
          </v-btn>
        </span>
        <span v-if="displayLogoutBtn" style="display: flex; justify-content: center; margin-top: 3em">
          <v-btn
            :color="$vuetify.theme.currentTheme.primary"
            :dark="$vuetify.theme.dark"
            class="primary"
            depressed
            tile
            @click="logout"
          >
            {{ $t('burgerMenu.logout') }}
          </v-btn>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    name: 'ErrorsPage',
    props: {
      error: {
        type: String,
        default: 'notAuthorized',
      },
      displayRefreshBtn: {
        type: Boolean,
        default: false,
      },
      displayLogoutBtn: {
        type: Boolean,
        default: true,
      },
      storeName: {
        type: String,
        default: '',
      },
    },
    methods: {
      logout() {
        this.$auth.logout()
      },
      getErrorMessage() {
        let message = this.$t('errors.' + this.error)
        if (this.error === 'unauthorizedStore') {
          message = message.replace('{storeName}', this.storeName)
        }
        return message
      },
    },
  }
</script>
